import React from 'react';
export function UrgencyBar() {
  return <div className="fixed top-0 left-0 right-0 z-50 bg-[#F4F3F3] py-3 px-4 text-center" data-id="element-198">
      <p className="text-sm md:text-base font-medium text-dark" data-id="element-199">
        ⚠️ <span className="text-primary" data-id="element-200">ATENCIÓN:</span> Oferta de lanzamiento
        de $110 MXN termina hoy{' '}
        <span className="text-primary" data-id="element-201">(Quedan 14 cupos)</span>.
      </p>
    </div>;
}